import { render, staticRenderFns } from "./ProgramMentorsSuggestionsList.vue?vue&type=template&id=4bcc5e26"
import script from "./ProgramMentorsSuggestionsList.vue?vue&type=script&lang=js"
export * from "./ProgramMentorsSuggestionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports